export default "__VITE_ASSET__CosYDLRU__"